// Classic's shell slots. Classic pages mount their own chrome (34 mount
// sites, §4.5), so these are declared for the contract, not used by the host.

import type { HeaderProps } from '../../core/template/types'
import Navigation from './components/Navigation'

export function ClassicHeader({ variant }: HeaderProps) {
  return <Navigation noSpacer={variant === 'overlay'} />
}
